/*
  Scroll to product image on variant change
  -----------------------------------------
  On mobile the swatches sit below the gallery, so when a shopper picks a colour
  the image does change — they just never see it. This scrolls the page back up
  to the gallery so the chosen colour is actually on screen.

  It listens to the `variant:changed` event that product-info.js already
  dispatches on `document` (assets/product-info.js:233), AFTER the media has
  been swapped. Nothing else in the theme listens to it, so this costs nothing
  until a variant actually changes: no polling, no observers, no scroll or
  resize listeners.

  The visibility guard is the point of the whole file. On desktop layout-6 the
  gallery sits beside the picker and is already fully visible; scrolling there
  would yank the page for no reason. Testing the rect instead of a breakpoint
  means it behaves correctly in all 7 gallery layouts without hardcoding any.
*/
(function () {
  var host = document.querySelector('[data-scroll-to-media="true"]');
  if (!host) return;

  var gallery = document.getElementById(host.dataset.galleryId);
  if (!gallery) return;

  document.addEventListener('variant:changed', function () {
    var rect = gallery.getBoundingClientRect();
    var offset = (window.MinimogSettings && MinimogSettings.headerHeight) || 66;

    // Already comfortably in view — leave the page where it is.
    if (rect.top >= offset && rect.bottom <= window.innerHeight) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    window.scrollTo({
      behavior: reduce ? 'auto' : 'smooth',
      top: rect.top - document.body.getBoundingClientRect().top - offset - 12
    });
  });
})();
